/**
 * Programmatic scroll helper.
 *
 * Routes through the global Lenis instance when available so scrolls are
 * smooth and consistent with user wheel scrolls. Falls back to native
 * `scrollIntoView` if Lenis isn't mounted yet (e.g. very early render
 * or future routes that opt out of <SmoothScrollProvider />).
 */
export function scrollToElement(id: string) {
  const el = document.getElementById(id);
  if (!el) return false;

  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(el, { offset: 0 });
    return true;
  }

  el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
}

export function scrollToTop() {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(0);
    return;
  }
  window.scrollTo({ top: 0, behavior: "smooth" });
}
